import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';
import routeGuard from './routeGuard';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(routeGuard);

export default router;
